import AssessmentServiceApi from "../../services/assessment-api";
import Types from "./types";

const updateEmail = (data) => {
  return function () {
    return AssessmentServiceApi.updateUserEmail(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Email Update Error:", error));
  };
};

export { updateEmail };
